<template>
  <div class="shop">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          <template v-if="!data.shop.id">
            {{ util.language('新增', 'New ') }}
          </template>
          <template v-else>
            {{ util.language('编辑', 'Edit ') }}
          </template>
          {{ util.language('店铺', 'Shop') }}
        </el-text>
        <el-button-group>
          <el-button @click="router.go(-1)">{{ util.language('返回', 'Back') }}</el-button>
          <el-button type="primary" @click="save()" :loading="loading.save">{{ util.language('保存', 'Save') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="ID" v-if="data.shop.id">
        <el-input v-model="data.shop.id" disabled />
      </el-form-item>
      <el-form-item :label="util.language('店铺编号', 'Code')">
        <el-input v-model="data.shop.code" v-if="!data.shop.id" />
        <el-text v-else>{{ data.shop.code }}</el-text>
      </el-form-item>
      <el-form-item :label="util.language('英文名', 'English Name')">
        <el-input v-model="data.shop.enName" />
      </el-form-item>
      <el-form-item :label="util.language('中文名', 'Chinese Name')">
        <el-input v-model="data.shop.cnName" />
      </el-form-item>
      <el-form-item :label="util.language('发票抬头', 'Invoice Header')">
        <el-input v-model="data.shop.invoiceHeader" />
      </el-form-item>
      <el-form-item :label="util.language('电话号', 'Phone')">
        <el-input v-model="data.shop.phone" />
      </el-form-item>
      <el-form-item :label="util.language('地址', 'Address')">
        <el-input v-model="data.shop.addressDetail" />
      </el-form-item>
      <el-form-item :label="util.language('统一销售税HST（%）', 'Harmonized Sales Tax(%)')">
        <el-input-number style="width: 100%;" :controls="false" :precision="4" :min="0" v-model="data.shop.hstRate" />
      </el-form-item>
      <el-form-item :label="util.language('联邦销售税GST（%）', 'Goods and Services Tax(%)')">
        <el-input-number style="width: 100%;" :controls="false" :precision="4" :min="0" v-model="data.shop.gstRate" />
      </el-form-item>
      <el-form-item :label="util.language('省级销售税PST（%）', 'Provincial Sales Tax(%)')">
        <el-input-number style="width: 100%;" :controls="false" :precision="4" :min="0" v-model="data.shop.pstRate" />
      </el-form-item>
      <el-form-item :label="util.language('魁北克消费税QST（%）', 'Quebec Sales Tax(%)')">
        <el-input-number style="width: 100%;" :controls="false" :precision="4" :min="0" v-model="data.shop.qstRate" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const show = reactive({
  roles: []
})
const loading = reactive({
  save: false
})
const pageParam = cache.getObject(cache.keys.pageParam + "shop")
const data = reactive({
  shop: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {}
})
data.shop.hstRate = math.multiply(data.shop.hstRate, 100)
data.shop.gstRate = math.multiply(data.shop.gstRate, 100)
data.shop.pstRate = math.multiply(data.shop.pstRate, 100)
data.shop.qstRate = math.multiply(data.shop.qstRate, 100)

const save = () => {
  loading.save = true
  if (!data.shop.id) {
    api.post('/backend/shop/addShop', {
      code: data.shop.code,
      enName: data.shop.enName,
      cnName: data.shop.cnName,
      invoiceHeader: data.shop.invoiceHeader,
      phone: data.shop.phone,
      addressDetail: data.shop.addressDetail,
      hstRate: math.divide(data.shop.hstRate, 100),
      gstRate: math.divide(data.shop.gstRate, 100),
      pstRate: math.divide(data.shop.pstRate, 100),
      qstRate: math.divide(data.shop.qstRate, 100),
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  } else {
    api.post('/backend/shop/setShop', {
      id: data.shop.id,
      enName: data.shop.enName,
      cnName: data.shop.cnName,
      invoiceHeader: data.shop.invoiceHeader,
      phone: data.shop.phone,
      addressDetail: data.shop.addressDetail,
      hstRate: math.divide(data.shop.hstRate, 100),
      gstRate: math.divide(data.shop.gstRate, 100),
      pstRate: math.divide(data.shop.pstRate, 100),
      qstRate: math.divide(data.shop.qstRate, 100),
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  }
}
</script>

<style lang="less">
.shop {
  margin: auto;
  max-width: 900px;
}
</style>